import EvaluateRequest from "../../EvaluateRequest"
import WorkspaceConfig from "../../../workspace/config/WorkspaceConfig"
import ConfigEntity from "../../../workspace/config/entity/ConfigEntity"

/**
 * Marker for evaluate requests resolved by local evaluation (against the on-device workspace config).
 *
 * Kept as an interface (not an abstract class): its job is to narrow the inherited `workspace`
 * and `entity` to the local config types, so local evaluators access the rich `WorkspaceConfig`.
 * Concrete requests do `implements LocalEvaluateRequest, XxxEvaluateRequest`.
 */
export default interface LocalEvaluateRequest extends EvaluateRequest {
  workspace: WorkspaceConfig
  entity: ConfigEntity
}

// A local request is discriminated by its workspace being the on-device config.
export function isLocalEvaluateRequest(request: EvaluateRequest): request is LocalEvaluateRequest {
  return request.workspace instanceof WorkspaceConfig
}
